@if (card(); as coupon) {
  <article
    class="sav-store-offer-card"
    [class.sav-offer-card-exclusive]="showExclusiveStyle()"
    [class.sav-offer-card-affiliate]="isAffiliateOffer() && !showExclusiveStyle()"
    [class.sav-offer-card-expired]="isExpired()"
    [class.sav-offer-card-text-discount]="!coupon.affiliateStoreLogoUrl && !coupon.imageUrl"
    [attr.aria-label]="coupon.title"
  >
    @if (coupon.isExclusive && !isExpired()) {
      <span class="sav-exclusive-badge"
        ><span aria-hidden="true">★</span>SavingArena Exclusive</span
      >
    }
    <div class="sav-offer-main">
      @if (coupon.affiliateStoreLogoUrl) {
        <div class="sav-offer-discount sav-offer-affiliate">
          <!--
            Eager, as the bare <img> was: the lead offer sits directly under the store hero, in the
            first viewport. `decorative` because the badge above the title already carries the
            brand's name — see `typeBadgeLabel`.
          -->
          <app-store-logo
            [logoUrl]="coupon.affiliateStoreLogoUrl"
            [name]="coupon.affiliateStoreName"
            loading="eager"
            decorative
          />
        </div>
      } @else if (coupon.imageUrl) {
        <div class="sav-offer-discount sav-offer-discount-image">
          <img [src]="coupon.imageUrl" [alt]="coupon.title" width="120" height="120" />
        </div>
      } @else {
        <div class="sav-offer-discount">
          <strong class="sav-coupon-badge-text" [style.--badge-chars]="coupon.offerPrimaryChars">{{
            coupon.offerPrimary
          }}</strong>
          @if (coupon.offerSecondary) {
            <span
              class="sav-coupon-badge-text"
              [style.--badge-chars]="coupon.offerSecondaryChars"
              >{{ coupon.offerSecondary }}</span
            >
          }
          <!--
            Phones only. There the discount is a single line of type rather than a column, and the
            offer type joins it in the same style ("50% OFF DEAL") instead of sitting as a lone pill
            underneath. The pill in the badge row is hidden at the same width, so exactly one of the
            two is ever visible — and exposed to assistive tech — at any viewport.
          -->
          @if (inlineTypeLabel(); as inlineType) {
            <span class="sav-coupon-badge-text sav-offer-type-inline">{{ inlineType }}</span>
          }
        </div>
      }

      <div class="sav-offer-content">
        <div class="sav-offer-badge-row">
          <!-- A partner brand's name when the offer belongs to another store, so the card says
               whose deal it is instead of a generic "Offer". -->
          <p
            class="sav-offer-type"
            [class.is-store]="isAffiliateOffer()"
            [style.font-size]="typeBadgeFontSize()"
          >
            {{ typeBadgeLabel() }}
          </p>
          @if (isExpired()) {
            <span class="sav-offer-verified">Unverified</span>
          } @else {
            @for (badge of coupon.badges; track badge.label) {
              <span class="sav-offer-badge-pill" [style.background]="badge.color">
                @if (badge.iconUrl) {
                  <img
                    class="sav-offer-badge-icon"
                    [src]="badge.iconUrl"
                    [alt]="badge.label + ' icon'"
                    width="14"
                    height="14"
                  />
                }
                {{ badge.label }}
              </span>
            }
            @if (variant() === 'featured' && coupon.isTopPick) {
              <span class="sav-top-pick-badge">Top Pick</span>
            }
          }
        </div>
        <h3>{{ coupon.title }}</h3>
        @if (coupon.description) {
          <!--
            Expand/collapse with no JavaScript: the checkbox holds the state and CSS lifts the clamp
            off its sibling. The description is printed in full regardless — the clamp only hides it
            visually — so the whole offer text is in the server-rendered HTML for crawlers either way.
            The input stays in the accessibility tree (offscreen, not `hidden`) so it is still
            focusable and togglable by keyboard.
          -->
          <!-- The visible "Read more" text is CSS-generated on the label, which gives this input
               no accessible name (Lighthouse "Form elements must have labels", surfaced by the
               Agentic Browsing category). The name lives here instead. -->
          <input
            type="checkbox"
            class="sav-offer-desc-toggle"
            [id]="descriptionToggleId()"
            [attr.aria-controls]="descriptionToggleId() + '-text'"
            aria-label="Show the full offer description"
          />
          <p class="sav-offer-desc" [id]="descriptionToggleId() + '-text'">
            {{ coupon.description }}
          </p>
          @if (descriptionIsClamped()) {
            <label class="sav-offer-desc-more" [attr.for]="descriptionToggleId()"></label>
          }
        }
      </div>

      <div class="sav-offer-action">
        @if (coupon.code) {
          <div class="sav-code-shell">
            <span class="sav-code-value" aria-hidden="true">{{ coupon.code }}</span>
            <button type="button" class="sav-btn-code" (click)="onAction()">
              {{ coupon.actionLabel }}
            </button>
          </div>
        } @else {
          <button type="button" class="sav-btn-deal" (click)="onAction()">
            {{ coupon.actionLabel }}
          </button>
        }
        <p class="sav-offer-expiry">{{ coupon.expiryText }}</p>
      </div>
    </div>
  </article>
}
